import { render, staticRenderFns } from "./96gyjtysyy.vue?vue&type=template&id=0886260e&"
import script from "./96gyjtysyy.vue?vue&type=script&lang=js&"
export * from "./96gyjtysyy.vue?vue&type=script&lang=js&"
import style0 from "./96gyjtysyy.vue?vue&type=style&index=0&id=0886260e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports